import { useList } from "@pankod/refine-core";
import { DATAPROVIDER_COUNT, RESOURCE_PATH } from "scripts/site";

export const EngagementProgramCount: React.FC<{
    programId: string
}> = ({ programId }) => {

    const { data: enggProgCount, isLoading } = useList({
        dataProviderName: DATAPROVIDER_COUNT,
        resource: RESOURCE_PATH.ENGAGEMENTPROGRAM,
        config: {
            filters: [
                {
                    field: "programId",
                    operator: "eq",
                    value: programId
                }]
        },
        queryOptions: {
            enabled: !!programId
        }
    });
    return (isLoading ? <>Loading...</> :
        <>{enggProgCount?.data ?? "0"}</>
    );
}